import type { ReactChild } from 'react';
import React, { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { EditionSectionMessage } from '@confluence/change-edition/entry-points/sectionMessages.ts';

import { ConfluenceEdition } from './__types__/AdminKeyEligibilityQuery.ts';

export type AdminKeyMessageCardProps = {
	eventName: string;
	type: 'page' | 'space';
} & (
	| {
			actions: ReactChild;
			message: ReactChild;
			title: ReactChild;
	  }
	| { children: ReactChild }
);

export function AdminKeyMessageCard(props: AdminKeyMessageCardProps) {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const { eventName, type: entryType } = props;

	useEffect(() => {
		// Fire analytics events only on the first time through
		if (createAnalyticsEvent) {
			createAnalyticsEvent({
				type: 'sendScreenEvent',
				data: {
					name: eventName,
					action: 'viewed',
					actionSubject: 'page',
					actionSubjectId: eventName,
				},
			}).fire();

			createAnalyticsEvent({
				type: 'sendScreenEvent',
				data: {
					name: eventName,
					attributes: {
						entryType,
					},
				},
			}).fire();
		}
	}, [createAnalyticsEvent, eventName, entryType]);

	const children = props['children'];
	const title = props['title'];
	const message = props['message'];
	const actions = props['actions'];

	return React.Children.count(children) ? (
		children
	) : (
		<EditionSectionMessage
			edition={ConfluenceEdition.PREMIUM}
			title={title}
			body={message}
			actions={actions}
		/>
	);
}
